import { Component, OnInit, Input, Output, EventEmitter, Optional } from '@angular/core';
import { HeaderComponent } from 'app/header/header.component';
import { CurrentUser } from 'app/services/currentUser.service';
import { AppHeaderComponent } from 'app/header/appHeader/appHeader.component';
import { Router } from '@angular/router';
import { UploadService } from '../upload/upload.service';
import { ContribComponent } from 'app/+projects/contrib/contrib.component';
import { Store } from '@ngrx/store';
import * as fromApp from '../../../app.reducer';
import { ContribService } from 'app/+projects/contrib/contrib.service';
import { CompactUploadProgressComponent } from 'app/+stories/uploadProgress/compact-upload-progress/compactUploadProgress.component';

@Component({
  selector: 'contrib-waiting',
  templateUrl: './waiting.component.html',
  styleUrls: ['./waiting.component.scss'],
  providers: [HeaderComponent, ContribComponent, CompactUploadProgressComponent],
})
export class WaitingComponent implements OnInit {
  @Input() step;
  @Input() totalSteps;
  @Input() isMobile;
  @Input() owner;
  @Input() projectInfo;
  @Input() invitationToken;
  @Output() next = new EventEmitter();
  public skipLog: boolean;
  public signUp: boolean ;
  private uploadStatus;
  public uploadDone: boolean;

  user;
  load;
  constructor(
    private islogin: HeaderComponent,
    private currentUser: CurrentUser,
    private router: Router,
    private store: Store<fromApp.AppState>,
    @Optional() private contribComponent: ContribComponent) {
    }

  ngOnInit() {
    this.user = this.currentUser.getFirstName();
    if (this.islogin.isLoggedIn() && !this.currentUser.get().guest) {
      this.skipLog = true;
    }
    this.store.select('new').subscribe(storyUploading => {
      this.uploadStatus = storyUploading;

      if (!this.signUp && storyUploading.uploadStatus.progressPercent === 100) {
        this.uploadDone = true;
        this.contribComponent.done = true;
        this.router.navigate(['/projects/' + this.projectInfo.id + '/contribute'],
        { queryParams: { token: this.invitationToken, done: true} });
      }
    });
  }
}
